module.exports = __webpack_public_path__ + "static/media/title.18d42128.svg";